import Resource from '../../../api/resources/Resource'

class SampleServices extends Resource {
    async createSample(labId, casId, sample) {
        const response = await this.axios.post(`/registry/laboratories/${labId}/cases/${casId}/samples`, sample)
        return response.data
    }

    async updateSample(labId, casId, sampleId, sample) {
        const response = await this.axios.put(`/registry/laboratories/${labId}/cases/${casId}/samples/${sampleId}`, sample)
        return response.data
    }

    async getSamplesByCaseId(labId, casId) {
        const response = await this.axios.get(`/registry/laboratories/${labId}/cases/${casId}/samples`)
        return response.data
    }

    async deleteSample(labId, casId, sampleId) {
        return this.axios.delete(`/registry/laboratories/${labId}/cases/${casId}/samples/${sampleId}`)
    }

    async updateSampleFields(labId, casId, sampleId, sample) {
        const response = await this.axios.put(`/registry/laboratories/${labId}/cases/${casId}/samples/${sampleId}/fields`, sample)
        return response.data
    }

    async launchAutomatismsAndUpdateSample(labId, casId, sampleId, cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded, sample, process) {
        let params = { cancelPreviousAutomatisms, shouldAddPreformattedInsteadOfReplacing, applyTotalReplace, shouldCheckThatSectionsCanBeAdded }
        const response = await this.axios.put(`/registry/laboratories/${labId}/cases/${casId}/samples/${sampleId}/launchAutomatismsAndUpdateSample`,
            sample,
            { params })
        return response.data
    }

    async cancelAutomatismsAndUpdateSample(labId, casId, sampleId, sample) {
        const response = await this.axios.put(`/registry/laboratories/${labId}/cases/${casId}/samples/${sampleId}/cancelAutomatismsAndUpdateSample`, sample)
        return response.data
    }
    async deleteSamplesBatch(laboratoryId, caseId, samples) {
        const params = {
            entityIdentifiers: samples.map(sample => sample.id)
        }
        return this.axios.delete(`/registry/laboratories/${laboratoryId}/cases/${caseId}/samples/deleteBatch`, { data: params }).then(response => response.data)
    }
    async getNextSamplesNumbers(laboratoryId, caseId, samplesNumber, numberOfSamples) {
        return this.axios.get(`/registry/laboratories/${laboratoryId}/cases/samples/getNextSampleNumbers`,
            {
                params: {
                    caseId,
                    sampleNumbers: samplesNumber,
                    quantity: numberOfSamples }
            }).then(response => response.data)
    }
    async searchSampleByLabel(laboratoryId, sampleLabel) {
        return this.axios.get(`/registry/laboratories/${laboratoryId}/samples/searchByLabel`,
            {
                params: {
                    sampleLabel: sampleLabel
                }
            }).then(response => response.data)
    }
    async changeSampleAsSampleOnSlide(laboratoryId, caseId, sampleId, checkChildren) {
        const response = await this.axios.put(`/registry/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/changeSampleAsSampleOnSlide`, null, { params: { checkChildren } })
        return response.data
    }
}

export default new SampleServices()
